<template>
  <div>
    <div>
      <div id="table">
        <vxe-table row-id="id" :data="table" align="left" :row-style="setRowClass" ref="box">
          <vxe-table-column field="strategy_id" show-overflow min-width="160" title="ID"></vxe-table-column>
          <vxe-table-column field="memo" show-overflow min-width="120" title="备注"></vxe-table-column>
          <vxe-table-column field="strategy_typeshow" show-overflow min-width="120" title="策略类型"></vxe-table-column>
          <vxe-table-column field="product_name" show-overflow min-width="120" title="产品名称"></vxe-table-column>
          <vxe-table-column field="success_total" show-overflow min-width="60" title="成功数"></vxe-table-column>
          <vxe-table-column field="failed_total" show-overflow min-width="60" title="失败数"></vxe-table-column>
          <vxe-table-column field="updated_at" show-overflow min-width="120" title="更新时间"></vxe-table-column>
          <vxe-column title="操作" min-width="100">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button size="S" type="text" name="btn2" slot="reference" @click="handleShowDetail(slotProps.row)"
                  >查看</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button size="S" type="text" name="btn2" slot="reference" @click="handleDelete(slotProps.row)">删除</v-button></span
              >
              <span class="handle-button"
                ><v-button size="S" type="text" name="btn2" slot="reference" @click="handleExport(slotProps.row)">导出</v-button></span
              >
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination
        v-if="total"
        @change-page="changePage"
        @change-size="changeSize"
        :total="total"
        name="page-basic"
        is-show-total
        is-change-size
        is-input-page
        :current-page="currentPage"
      ></v-pagination>
      <v-loading class="loading-box" size="L" :visible="loading" text="加载中..." name="loading1"></v-loading>
    </div>
    <Del :showInputDialog.sync="deleteVisible" :row="selectRow" ref="Del"></Del>
    <Download :showInputDialog.sync="downloadVisible" :row="selectRow" ref="Download"></Download>
    <DetailLog :showInputDialog.sync="detailLogVisible" :row="selectRow" ref="DetailLog"></DetailLog>
  </div>
</template>

<script>
import Del from "@/components/log-service/force-upgrade/del.vue";
import Download from "@/components/log-service/force-upgrade/download.vue";
import DetailLog from "@/components/log-service/force-upgrade/detail-log.vue";
const STRATEGY_TYPE = {
  basesn: "基于设备KEY",
  baseproduct: "基于产品名称",
};
export default {
  components: { Del, DetailLog, Download },
  props: {
    productKey: {},
    deviceKey: {},
    searchValue: {},
  },
  data() {
    return {
      loading: false,
      downloadVisible: false,
      detailLogVisible: false,
      deleteVisible: false,
      selectRow: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      table: [],
    };
  },
  watch: {
    deviceKey(newdata) {
      this.deviceKey = newdata;
    },
    productKey(newdata) {
      this.productKey = newdata;
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    document.getElementsByClassName("vxe-table--body-wrapper")[0].addEventListener("scroll", this.throttle(this.lazyLoading, 1000));
  },
  methods: {
    //节流函数
    throttle(fn, delay) {
      var timer = null;
      return function() {
        clearTimeout(timer);
        timer = setTimeout(function() {
          fn();
        }, delay);
      };
    },
    lazyLoading() {
      const target = document.getElementsByClassName("vxe-table--body-wrapper")[0];
      const scrollTop = target.scrollTop; // 滚动条滚动时，距离顶部的距离
      const windowHeight = target.clientHeight; // 可视区的高度
      const scrollHeight = target.scrollHeight; // 滚动条的总高度
      if (scrollTop + windowHeight + 1 > scrollHeight) {
        //数据小于每组数量  已到最后一页
        if (this.pageSize > this.total) {
          this.$message.warn("已经是最后一页了");
          return;
        }
        this.loading = true;
        this.getData();
      }
    },
    setRowClass({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "background: #fafafa";
      }
    },
    async getData(search) {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        page_num: this.currentPage,
        page_size: this.pageSize,
        search: search || this.searchValue,
      };
      const res = await this.$getData("/td/td-iot-api/iot/upgrade/force/statistic/page", subData, false);
      if (res.code === 0) {
        this.table = [...res.data.list];
        this.table.forEach((x) => {
          x.strategy_typeshow = STRATEGY_TYPE[x.strategy_type];
        });
        this.total = res.data.total;
        this.loading = false;
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },

    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.getData();
    },
    handleDelete(row) {
      this.deleteVisible = !this.deleteVisible;
      this.selectRow = { ...row };
    },
    handleShowDetail(row) {
      this.detailLogVisible = !this.detailLogVisible;
      this.selectRow = { ...row };
    },
    handleExport(row) {
      this.downloadVisible = !this.downloadVisible;
      this.selectRow = { ...row };
    },
  },
};
</script>
<style lang="scss">
.low-title {
  font-size: 18px;
}
#table .vxe-table--body-wrapper {
  max-height: 530px;
}
</style>
